var appConfig = {
    isDebug: true,
    apiRoute: '/api'
};

exports.appConfig = appConfig;


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/config.js
// module id = ../../../../../src/config.js
// module chunks = main